/** Converts the params into a search string. */
export function toQueryString(params: Record<string, string | number | boolean>): string {
  const str = Object.entries(params)
    .filter(([, value]) => value !== false)
    .map(([key, value]) => value === true ? key : `${key}=${value}`)
    .join('&');

  return str ? `?${str}` : '';
}